import Image from "next/image";
import { conditions, controllbarIconSize } from "../../../../../helpers";
import { ConditionName, IFullScreenIconProps } from "../../../../../interfaces";
import IMAGES from "../../../../../images/importImages";
import { useAppSelector } from "redux-share";
import { shallowEqual } from "react-redux";

const FullScreenIcon = (props: IFullScreenIconProps) => {
    useAppSelector(
        ({ videoData: { isComplexPortrait, videoElementSizeInfo, params } }) => ({ isComplexPortrait, videoElementSizeInfo, params }),
        shallowEqual
    );
    useAppSelector(({ controller: { isFullScreen, showMiniPlayer } }) => ({ isFullScreen, showMiniPlayer }), shallowEqual);

    return (
        <div className={`pl-flex pl-items-center`} onClick={props.onClick}>
            {conditions(ConditionName.isSplusEnvironment) ? (
                <i
                    className={`fa-solid ${conditions(ConditionName.isFullScreen) ? "fa-compress" : "fa-expand"} pl-text-white pl-cursor-pointer ${
                        conditions(ConditionName.isFullMobilePortrait) || !conditions(ConditionName.isMiniPlayer)
                            ? controllbarIconSize.otherFontAwesome
                            : controllbarIconSize.miniPlayerFontAwesome
                    }`}
                    onMouseOver={props.onMouseOver}
                    onMouseLeave={props.onMouseLeave}
                />
            ) : (
                <Image
                    src={conditions(ConditionName.isFullScreen) ? IMAGES.nonFullScreen : IMAGES.fullScreen}
                    alt="fullScreen-icon"
                    className={`pl-cursor-pointer`}
                    width={
                        conditions(ConditionName.isFullMobilePortrait) || !conditions(ConditionName.isMiniPlayer)
                            ? controllbarIconSize.other
                            : controllbarIconSize.miniPlayer
                    }
                    height={
                        conditions(ConditionName.isFullMobilePortrait) || !conditions(ConditionName.isMiniPlayer)
                            ? controllbarIconSize.other
                            : controllbarIconSize.miniPlayer
                    }
                    onMouseOver={props.onMouseOver}
                    onMouseLeave={props.onMouseLeave}
                />
            )}
        </div>
    );
};

export default FullScreenIcon;
